import React from "react";
import { useEffect } from "react";
import GoogleAnalytics from "react-ga";
import { useLocation } from "react-router";
import { useAppProvider } from "./hooks/useAppProvider";

export const AppContext = React.createContext<
  ReturnType<typeof useAppProvider>
>({} as ReturnType<typeof useAppProvider>);

export const AppProvider: React.FC = ({ children }) => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV === "production")
      GoogleAnalytics.pageview(pathname + search);
  }, [pathname, search]);

  return (
    <AppContext.Provider value={useAppProvider()}>
      {children}
    </AppContext.Provider>
  );
};
